<template>
  <v-menu
    v-model="isOpen"
    fixed
    offset-y
    top
    :min-width="400"
    :max-width="400"
    :nudge-left="112"
    :position-x="positionX"
    :position-y="positionY"
  >
    <v-card
      v-if="(
        attempt
        && item
      )"
    >
      <div class="question_header">
        <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px">
          <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="attempt.b_thumbnail"/></button>
        </v-responsive>
        <span>{{item.p_item_name}}</span>
      </div>
      <div class="question-popover">
        <div class="question-format">
          <ul>
            <li><span class="bold" style="margin-right:3px;">Score:</span> {{attempt.module_item_attempt_id ? attempt.score : '-'}}</li>
            <li><span class="bold" style="margin-right:3px;">Points:</span> {{attempt.module_item_attempt_id ? attempt.ba_points : '-'}}</li>
            <li><span class="bold" style="margin-right:3px;">Time Spent (min):</span> {{attempt.module_item_attempt_id ? attempt.ba_engaged_minutes : '-'}}</li>
            <li><span class="bold" style="margin-right:3px;">Attempted:</span> {{attempt.module_item_attempt_id ? attempt.ba_attempted : '-'}}</li>
          </ul>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="question_footer_gradebook">
        <v-btn class="branded-background text-white"
        @click="clickFunction({property: attempt.moduleItemId, label: attempt.bulb_name})"
        aria-live="assertive"
        >
          View Interactions
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'InteractionResults',
  props: {
    event: Event,
    item: Object,
    attempt: Object,
    clickFunction: Function,
  },
  data: () => ({
    isOpen: false,
    targetElement: null,
    buttonElement: null,
    positionX: 0,
    positionY: 0,
    tableBodyWrapperElement: null,
  }),
  methods: {
    handlePlaylistGradebookScroll: _.throttle(function() {
      const bounding = this.targetElement.getBoundingClientRect();
      this.$set(this, 'positionX', bounding.left);
      this.$set(this, 'positionY', bounding.top);
    }, 250, {
      trailing: true,
    }),
    toggleTableBodyWrapperScrollListener(isAddingListener) {
      if (!this.tableBodyWrapperElement) {
        this.tableBodyWrapperElement = document.querySelector('.el-table .el-table__body-wrapper');
      }
      if (!this.tableBodyWrapperElement) return;
      this.tableBodyWrapperElement[isAddingListener ? 'addEventListener' : 'removeEventListener']('scroll', this.handlePlaylistGradebookScroll);
    },
    async initializeInteractionResults() {
      this.toggleTableBodyWrapperScrollListener(false);
      await this.$timer(50);
      this.buttonElement = this.event.target.closest('button');
      this.buttonElement.classList.add('v-btn--active', 'orange-border');
      this.targetElement = this.buttonElement.closest('div');
      const bounding = this.targetElement.getBoundingClientRect();
      this.positionX = bounding.left;
      this.positionY = bounding.top;
      this.isOpen = true;
      this.toggleTableBodyWrapperScrollListener(true);
    },
    disableInteractionResults() {
      this.buttonElement.classList.remove('v-btn--active', 'orange-border');
      this.toggleTableBodyWrapperScrollListener(false);
    },
  },
  watch: {
    event: 'initializeInteractionResults',
    isOpen(newValue) {
      if (!newValue) this.disableInteractionResults();
    },
  },
}
</script>